import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { TS_AppTools } from '../TS_AppTools/index.js';
import { LL_H_C, LL_V_L } from '../Layouts/index.js';
import { TS_PropRenderer } from '../TS_PropRenderer/index.js';
import { TS_TextArea } from './TS_TextArea.js';
import './ATS_TextArea.scss';
export class ATS_TextArea extends ComponentSync {
    static Screen = {
        group: 'TS Components',
        name: 'TS_TextArea',
        key: 'ts-textarea',
        renderer: this,
    };
    render() {
        return _jsxs(LL_V_L, { className: 'ats__ts-text-area', children: [TS_AppTools.renderPageHeader('TS_TextArea Tests'), _jsxs(LL_H_C, { className: 'ats__ts-text-area__content', children: [this.renderRegularTextArea(), this.renderResizingTextArea()] })] });
    }
    renderRegularTextArea = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Regular Text Area', children: _jsx(TS_TextArea, { type: 'text', value: this.state.regularValue, onChange: value => this.setState({ regularValue: value }) }) });
    };
    renderResizingTextArea = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Resizing Text Area', children: _jsx(TS_TextArea, { type: 'text', resizeWithText: true, value: this.state.resizeValue, onChange: value => this.setState({ resizeValue: value }) }) });
    };
}
//# sourceMappingURL=ATS_TextArea.js.map